$(function(){

    $('.main-menu__hamburger').on('click', function(){
        $(this).toggleClass('is-active');
        $('.main-menu').toggleClass('main-menu--mobile-active');
        $('html').toggleClass('no-scroll');
    });

});